import { ChangeEvent, FC } from 'react'
import styled from 'styled-components'
import { Close, MagnifyingGlass } from 'svgIcons'
import TextField from 'app.components/inputs/TextField'

interface IFKeywordInputProps {
  value: string
  onChange: (newValue: string) => void
  onReset: () => void
  className?: string
}

const KeywordInput: FC<IFKeywordInputProps> = ({
  value,
  onChange,
  onReset,
  className,
}) => {
  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    onChange(event.target.value)
  }

  return (
    <StyledWrapper className={className}>
      <MagnifyingGlass className="glass" />
      <TextField
        value={value}
        onChange={handleChange}
        placeholder="공고 제목, 기업명 검색"
        className="keyword-input"
      />
      <Close onClick={onReset} className="remove-icon" />
    </StyledWrapper>
  )
}

export default KeywordInput

const StyledWrapper = styled.div`
  display: flex;
  align-items: center;
  padding: 15px;
  height: 50px;
  border: 1px solid ${(props) => props.theme.line.line_1};
  border-radius: 5px;

  .glass {
    width: 16px;
    height: 16px;
  }

  .keyword-input {
    flex: 1;
    border: none;
  }

  .remove-icon {
    width: 16px;
    height: 16px;
    padding: 2px;
  }
`
